import React from 'react'
import { Box, Typography } from '@mui/material'
import MonthlyReportDrawer from './drawer/MonthlyReportDrawer'
import IndividualReportDrawer from './drawer/IndividualReportDrawer'

const LeaveSummaryTab = () => {
  return (
    <Box maxHeight={'calc(100vh - 182px)'}>
      <Box
        bgcolor="white.main"
        sx={{
          borderRadius: '3.5px',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center" px="16px" py="20px">
          <Box display="flex" alignItems="center" gap="16px">
            <Box>
              <Box
                height="45px"
                width="45px"
                borderRadius="100%"
                bgcolor="alternate.light"
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Box height="26px" width="26px" color="alternate.main">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"
                    />
                  </svg>
                </Box>
              </Box>
            </Box>
            <Box>
              <Typography marginBottom="4px" fontWeight="bold">
                Individual leave summary
              </Typography>
              <Typography variant="subtitle2" color="light-gray-text.main">
                Generate personalized leave summaries for specific staff members by selecting
                individual employees.
              </Typography>
            </Box>
          </Box>
          <Box>
            <IndividualReportDrawer />
          </Box>
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          px="16px"
          py="20px"
          borderTop={1}
          borderColor="gray-line.main"
        >
          <Box display="flex" alignItems="center" gap="16px">
            <Box>
              <Box
                height="45px"
                width="45px"
                borderRadius="100%"
                bgcolor="alternate.light"
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Box height="26px" width="26px" color="alternate.main">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"
                    />
                  </svg>
                </Box>
              </Box>
            </Box>
            <Box>
              <Typography marginBottom="4px" fontWeight="bold">
                Monthly leave summary
              </Typography>
              <Typography variant="subtitle2" color="light-gray-text.main">
                Generate comprehensive monthly leave summaries for all your employees.
              </Typography>
            </Box>
          </Box>
          <Box>
            <MonthlyReportDrawer />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default LeaveSummaryTab
